module.exports = __webpack_public_path__ + "static/media/Roboto-Black.5ebb24ee.ttf";